import { VehicleDetailsGroupOutput } from './vehicle-details-group-output.model';


export class VehicleGroupWithStatusOutput implements IVehicleGroupWithStatusOutput {
    /** The auto-generated id of the vehicle group master */
    vehicle_group_id!: number;
    /** The vehicle group name with 255 character limit */
    vehicle_group_name!: string;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The description with 500 character limit */
    description!: string;
    /** Manage status of vehicle group. 0 For De-active, 1 For Active */
    status!: number;
    vehicle_details_group!: VehicleDetailsGroupOutput[];

    constructor(data?: IVehicleGroupWithStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_group_id = _data["vehicle_group_id"];
            this.vehicle_group_name = _data["vehicle_group_name"];
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            this.description = _data["description"];
            this.status = _data["status"];
            if (Array.isArray(_data["vehicle_details_group"])) {
                this.vehicle_details_group = [] as any;
                for (let item of _data["vehicle_details_group"])
                    this.vehicle_details_group!.push(VehicleDetailsGroupOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleGroupWithStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleGroupWithStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_group_id"] = this.vehicle_group_id;
        data["vehicle_group_name"] = this.vehicle_group_name;
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        data["description"] = this.description;
        data["status"] = this.status;
        if (Array.isArray(this.vehicle_details_group)) {
            data["vehicle_details_group"] = [];
            for (let item of this.vehicle_details_group)
                data["vehicle_details_group"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IVehicleGroupWithStatusOutput {
    /** The auto-generated id of the vehicle group master */
    vehicle_group_id: number;
    /** The vehicle group name with 255 character limit */
    vehicle_group_name: string;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    /** The description with 500 character limit */
    description: string;
    /** Manage status of vehicle group. 0 For De-active, 1 For Active */
    status: number;
    vehicle_details_group: VehicleDetailsGroupOutput[];
}

